import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/pointCloudVertex.js
var name, shader;
var init_pointCloudVertex = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/pointCloudVertex.js"() {
    "use strict";
    init_shaderStore();
    name = "pointCloudVertex";
    shader = `#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
`;
    ShaderStore.IncludesShadersStore[name] = shader;
  }
});

export {
  init_pointCloudVertex
};
